import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const AboutUsPageRoute: CustomRouteObject = {
  path: routeNamesPaths.aboutUs,
  lazy: async () => {
    const { AboutUsPage } = await import('./ui')

    return {
      Component: AboutUsPage,
    }
  },
  nodeRef: createRef(),
}
